import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';
import { DEFAULT_PAGE_SIZE } from '../../../utils/Constants';

import {
    LOADING,
    LOAD_ORDERS_HISTORY_SUCCESS,
    CLEAR_ORDERS_HISTORY
} from '../../types';
import MessageUtils from "../../../utils/MessageUtils";

export const loadOrdersHistory = (restaurantId, currentPageNumber, searchQuery) => {
    return (dispatch, getState) => {
        doLoadOrdersHistory(restaurantId, currentPageNumber, searchQuery, dispatch, getState);
    }
}

export const doLoadOrdersHistory = (restaurantId, currentPageNumber, searchQuery, dispatch, getState) => {
    dispatch({ type: LOADING, payload: true });

    let orderIdParameter = '';
    let customerNameParameter = '';
    let customerEmailParameter = '';
    let customerPhoneParameter = '';
    let placedTimeParameter = '';
    let wantedTimeParameter = '';

    if (searchQuery !== undefined) {
        if (searchQuery.orderId !== undefined && searchQuery.orderId !== '') {
            orderIdParameter = `&id=${searchQuery.orderId}`
        }
        if (searchQuery.customerName !== undefined && searchQuery.customerName !== '') {
            customerNameParameter = `&customerName=${searchQuery.customerName}`
        }
        if (searchQuery.customerPhone !== undefined && searchQuery.customerPhone !== '') {
            customerPhoneParameter = `&customerPhone=${searchQuery.customerPhone}`
        }
        if (searchQuery.customerEmail !== undefined && searchQuery.customerEmail !== '') {
            customerEmailParameter = `&customerEmail=${searchQuery.customerEmail}`
        }
        if (searchQuery.placedTime !== undefined && searchQuery.placedTime !== '') {
            placedTimeParameter = `&placedTime=${searchQuery.placedTime.split('-').reverse().join('-')}`
        }
        if (searchQuery.wantedTime !== undefined && searchQuery.wantedTime !== '') {
            wantedTimeParameter = `&wantedTime=${searchQuery.wantedTime.split('-').reverse().join('-')}`
        }
    }
    if (!restaurantId) return dispatch({ type: LOADING, payload: false });
    const url = `/order/search?page=${currentPageNumber - 1}&size=${DEFAULT_PAGE_SIZE}&restaurantId=${restaurantId}${orderIdParameter}${customerNameParameter}${customerEmailParameter}${customerPhoneParameter}${placedTimeParameter}${wantedTimeParameter}`;

    axios().get(url)
        .then(response => loadOrdersHistorySuccess(dispatch, response))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:orderHistoryActions.loadOrdersFailure')));
}

const loadOrdersHistorySuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_ORDERS_HISTORY_SUCCESS, payload: response.data });
}

export const clearOrdersHistory = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_ORDERS_HISTORY });
    }
}

export const downloadOrderHistory = (pageNumber, searchQuery, restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const finalSearchQuery = getQueryParams(pageNumber, searchQuery, restaurantId);
        const url = `/order/download-search?${finalSearchQuery}`;

        axios().get(url)
            .then(res => {
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:notificationsActions.downloadStartedMsg'));
                // let blob = new Blob([res.data], { type: 'application/csv' });
                // let link = document.createElement('a');
                // link.href = window.URL.createObjectURL(blob);
                // link.download = `last_2000_orders_history_log.csv`;
                // link.click();i18n.t('actions:orderHistoryActions.downloadOrdersFailure')
            })
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, err.response.userMessage))
            .finally(dispatch({ type: LOADING, payload: false }));
    }
}

const getQueryParams = (pageNumber, searchQuery, restaurantId) => {
    const { customerName, customerEmail, customerPhone, orderId, placedTime, wantedTime } = searchQuery;
    let pageParam = '', sizeParam = '', customerNameParam = '', customerEmailParam = '', customerPhoneParam = '', orderIdParam = '', placedTimeParam = '', wantedTimeParam = '', restaurantIdParam = '';
    restaurantIdParam = restaurantId;
    pageParam = pageNumber;
    sizeParam = 10; // backend default 20

    if (customerName) {
        customerNameParam = `&customerName=${customerName}`;
    }

    if (customerEmail) {
        customerEmailParam = `&customerEmail=${customerEmail}`
    }

    if (customerPhone) {
        customerPhoneParam = `&customerPhone=${customerPhone}`;
    }

    if (orderId) {
        orderIdParam = `&id=${orderId}`;
    }

    if (placedTime) {
        placedTimeParam = `&placedTime=${placedTime.split('-').reverse().join('-')}`;
    }

    if (wantedTime) {
        wantedTimeParam = `&wantedTime=${wantedTime.split('-').reverse().join('-')}`;
    }

    return `page=${pageParam}&size=${sizeParam}&restaurantId=${restaurantIdParam}${customerNameParam}${customerEmailParam}${customerPhoneParam}${orderIdParam}${placedTimeParam}${wantedTimeParam}`;
}



// WEBPACK FOOTER //
// ./src/actions/restaurants/orders/OrdersHistoryAction.js